export default "__VITE_ASSET__D3iN6_3l__"